import styled from "styled-components";
import { Card, Row } from "antd";

export const HeaderContainer = styled(Row)`
  display: flex;
  justify-content: space-between;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CadastroCardNavigation = styled(Card)`
  width: 300px;
  height: 200px;
  margin: 2rem 1rem;
  background: #ffffff;
  box-shadow: 0px 5px 10px #d3d3d3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  cursor: pointer;
  transition: 200ms;
  overflow: hidden;
  :hover {
    border: ${(props) => ` 3px solid ${props.color}`};

    svg {
        color: ${(props) => `${props.color}`} !important;
    }
  }

  svg {
    color: #ddd !important;
  }
`;

const Container = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex: 1;
`;


const IconSVG = styled.i`
  color: #ddd;
  background-color: none;
  display: block;
  margin: 1rem auto;
  display: flex;
  justify-content: space-around;
`;

const Text = styled.h3`
  color: #4d4f5c;
  font-size: 1rem;
  text-align: center;
  margin: 1rem;
`;



export {
    CadastroCardNavigation,
    Container,
    IconSVG,
    Text
}
